import { PostGrid } from "../components/PostGrid";

function Economics() {
  return (
    <PostGrid 
      section="economics" 
      title="Economics Library" 
      description="Macro frameworks, monetary systems, and economic theories explained in a structured format." 
    />
  );
}

export default Economics;
